namespace SPA
{
	export namespace Navigation
	{

		export abstract class Navigation
			extends ui.base.HTMLPresentation
		{

			protected	m_List: 	Array<ui.base.BaseHTMLElement<HTMLLIElement>>;
			protected	m_UList:	ui.base.BaseHTMLElement<HTMLUListElement>;

			public constructor()
			{
				super( 'nav' );

				this.m_List		= new Array();
				this.m_UList	= new ui.base.BaseHTMLElement( 'ul' );
			}

			public UList(): ui.base.BaseHTMLElement<HTMLUListElement>
			{
				return this.m_UList;
			}

			public List(): Array<ui.base.BaseHTMLElement<HTMLLIElement>>
			{
				return this.m_List;
			}

			public AddSeperator(): void
			{
				this.m_List.push( new ui.base.BaseHTMLElement<HTMLLIElement>( 'li' ).append( ui.$$.hr() ) );
			}

			public AddMenuPoint(): ui.base.BaseHTMLElement<HTMLLIElement>
			{
				const li = new ui.base.BaseHTMLElement<HTMLLIElement>( 'li' );

				this.m_List.push( li );

				return li;
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): Navigation
			{
				this.appendTo( root );

				this.empty();
				this.m_UList.empty();

				this.m_List.forEach( ( li ) => this.m_UList.append( li ) );

				this.m_UList.appendTo( this );

				return this;
			}

		}

	}
}
